import Button from "devextreme-react/button";
import { useContext } from "react";
import { WorkOrderContext } from "../context/WorkOrderContext";
import { showErrorMessage } from "../../../../utils/messages";
import { LoadPagePanel } from "../../../../components";
import { useSendWorkOrderReminder } from "../api/send-wo-reminder";
import { alert } from "devextreme/ui/dialog";
import { OrderStatus } from "../../../../types/enums";

export default function SendReminderButton() {

	const { order, refetchOrder } = useContext(WorkOrderContext);

	const sendReminder = useSendWorkOrderReminder(
		() => {
			alert('The reminder email has been successfully sent to CFI.', "Reminder Sent");
			refetchOrder();
		},
		(error) => { showErrorMessage(error); }
	)

	return (
		<>
			<Button elementAttr={{ 'data-testid': 'btn-release-wo-from-pending' }}
				text="Send Reminder"
				icon="Inscyth-Email"
				className="release-from-pending-button"
				visible={order.details.orderStatusID === OrderStatus.Open && !order.details.reminderSent}
				disabled={sendReminder.isLoading}
				onClick={() => {
					sendReminder.mutate
						({ workOrderID: order.details.workOrderID });
				}}
			>
			</Button>
			<LoadPagePanel visible={sendReminder.isLoading} />
		</>
	)
}
